import React from 'react';
import TextBase from './TextBase';
import { TText } from './types';

const Small = ({ as = 'span', color = '', ...rest }: TText) => (
  <TextBase {...rest} as={as} kind="body-small" color={color} />
);

export default Small;
